// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Image from 'components/Image/Image'

class PageHeader extends React.Component {
	renderContent() {
		const { translate } = this.props
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		return (
			<div className="page-header-content">
				<div className="-title">
					{ page.category.primary.name &&
						<p className="-category" dangerouslySetInnerHTML={ { __html: page.category.primary.name } } />
					}

					<h1 dangerouslySetInnerHTML={ { __html: page.title.raw } } />

					{ page.subtitle.rendered &&
						<h2 dangerouslySetInnerHTML={ { __html: page.subtitle.rendered } } />
					}
				</div>
			</div>
		)
	}

	renderImage() {
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page
		let wrapClass = 'page-header-image'
		const { params, path } = this.props.match

		if ( ! page ) {
			return (
				<div className="page-header-image">
					<div className="-inner">

					</div>
				</div>
			)
		}

		// Show thin images at full width:
		if ( page.featured_image.aspect_ratio > 1.77 ) {
			wrapClass += ' is-extra-wide'
		}

		const imageWrapStyle = {
			paddingBottom: 100 / page.featured_image.aspect_ratio + '%'
		}

		const featuredImage = page.featured_image

		if ( featuredImage.url ) {
			return (
				<div className={ wrapClass }>
					<div className="-inner">
						<Image
							thumb={ featuredImage.thumb }
							url={ featuredImage.url }
							srcset={ featuredImage.srcset }
							sizes={ `(max-width: ${siteData.mobile_max_width}) 100vw, 1100px` }
							alt={ featuredImage.alt }
							focalPoint={ featuredImage.focal_point }
							width={ featuredImage.width }
							height={ featuredImage.height }
							wrapStyle={ imageWrapStyle }
						/>
					</div>
				</div>
			)
		}

		return null
	}

	render() {
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		const className = page.page_header_style ? page.page_header_style : 'page-header'

		if ( this.props.isLoading ) {
			return null
		} else {
			return (
				<div className={ className }>
					{ this.renderImage() }
					{ this.renderContent() }
				</div>
			)
		}

	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( PageHeader )
